import { render } from "./FormShippingAddress.vue?vue&type=template&id=50c0f7f1&scoped=true"
import script from "./FormShippingAddress.vue?vue&type=script&lang=js"
export * from "./FormShippingAddress.vue?vue&type=script&lang=js"

import exportComponent from "F:\\work\\1\\s\\vue-code\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50c0f7f1"]])

export default __exports__